import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from "@angular/router";
import {FeatureService} from "./feature.service";

@Injectable()
export class FeatureGuard implements CanActivate {
  constructor(
    private readonly features: FeatureService,
    private readonly router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot){
    if(this.features.isEnabled(route.data?.feature)) {
      return true;
    }
    this.router.navigate(['/']);
    return false;
  }
}
